/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : spinner.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

/**
 * @author Tahir Shaik - tahir@au79consulting.com
 * @date 11-06-2024
 * @description Spinner start action (increments active API count)
 */
export const startLoading = (count = 1) => {
  return {
    type: actionType.SPINNER_LOADING,
    payload: {
      totalLoadingCounts: count, // number of APIs started
    },
  };
};

/**
 * @author Tahir Shaik - tahir@au79consulting.com
 * @date 11-06-2024
 * @description Spinner stop action (decrements active API count)
 */
export const stopLoading = () => {
  return {
    type: actionType.SPINNER_LOADED,
  };
};
